const setInitialFormBDStructure = ({
  session,
  landingId,
  metadata = {},
  answers,
  uid,
}) => {
  const { sessionID, timestampStart } = session;
  return {
    sessionID,
    processed: false,
    uid,
    metadata: {
      userAgent: navigator.userAgent,
      ...metadata
    },
    timestampStart: parseInt(timestampStart),
    items: [
      {
        landingId,
        landedAt: parseInt(timestampStart),
        submittedAt: Date.now(),
        answers,
      },
    ],
  };
};

export default setInitialFormBDStructure;
